import { useTranslation } from 'react-i18next'
import { useUserSubscriptions } from '../../hooks/useUserSubscriptions'
import SubscriptionRow from '../../components/library/SubscriptionRow'

/**
 * Subskrypcje page.
 *
 * Full-width subscription list with poster, status labels, and tier-specific
 * preference modals. Uses a gold scrollbar without separate arrow buttons.
 */
export default function LibrarySubscriptionsPage() {
  const { t } = useTranslation()
  const { subscriptions, loading, completePayment, cancel } = useUserSubscriptions()

  if (loading) {
    return (
      <div className="bg-[var(--library-card-bg)] backdrop-blur-md rounded-[2rem] p-6 shadow-xl border border-[var(--library-border)] min-h-[400px]">
        <h2 className="font-climate text-2xl text-brand-blue mb-4">
          {t('library.mySubscriptions.title')}
        </h2>
        <p className="text-base text-brand-blue/80">{t('common.loading')}</p>
      </div>
    )
  }

  return (
    <div className="bg-[var(--library-card-bg)] backdrop-blur-md rounded-[2rem] p-6 shadow-xl border border-[var(--library-border)] min-h-[400px] flex flex-col">
      <h2 className="font-climate text-2xl text-brand-blue mb-4 shrink-0">
        {t('library.mySubscriptions.title')}
      </h2>

      <div className="flex-1 overflow-y-auto max-h-[600px] gold-scrollbar pr-2">
        {subscriptions.length === 0 ? (
          <p className="text-base text-brand-blue/80">{t('library.mySubscriptions.empty')}</p>
        ) : (
          subscriptions.map((sub) => (
            <SubscriptionRow
              key={sub.id}
              sub={sub}
              onCompletePayment={completePayment}
              onCancel={cancel}
            />
          ))
        )}
      </div>
    </div>
  )
}
